import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100VH"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
        >
          <CFView textCenter column center w="100%">
            <CFView column center mt="5%">
              <CFImage
                w="90%"
                src={mobileHeroText}
                alt="Sushi Mong Japanese hero text"
                zIndex={98}
              />
            </CFView>
            <CFView mt="25px" mb="35px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) bottom/ cover no-repeat`}
          zIndex={90}
          column
          justifyBetween
          alignStart
        >
          <CFView column justifyStart alignStart h="650px" mt="30px">
            <CFView>
              <CFImage
                h="400px"
                src={heroText}
                alt="Sushi Mong Japanese hero text"
                zIndex={98}
              />
            </CFView>
            <CFView mv="10px" ml="60px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
